/**
 * Contract status values allowed for users (must match backend User model enum).
 */
export const CONTRACT_STATUS_OPTIONS = [
  { value: 'not started', label: 'Not Started' },
  { value: 'not signed', label: 'Not Signed' },
  { value: 'in progress', label: 'In Progress' },
  { value: 'signed', label: 'Signed' },
];

/** Content types from User model (for filters and display). */
export const CONTENT_TYPE_OPTIONS = [
  { value: 'fashion', label: 'Fashion' },
  { value: 'travel', label: 'Travel' },
  { value: 'sports', label: 'Sports' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'technology', label: 'Technology' },
  { value: 'vlogger', label: 'Vlogger' },
  { value: 'musician', label: 'Musician' },
  { value: 'photography', label: 'Photography' },
  { value: 'health and fitness', label: 'Health & Fitness' },
  { value: 'home decor', label: 'Home Decor' },
  { value: 'beauty and personal care', label: 'Beauty & Personal Care' },
];

export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  BLOCKED: 'blocked',
};
